import PropTypes from "prop-types";
import React, { useState } from "react";
import { copyToClipboard } from "../../helpers/component_helpers";

const CodeBlock = ({ displayCode, codeToBeCopied, fontSize }) => {



  return (
    <div
      className="d-flex flex-row align-items-center justify-content-between mb-3 mt-1"
      style={{
        padding: "10px 5px",
        background: "rgba(23,23,23,0.45)",
        borderRadius: "5px",
      }}
    >
      <pre
        className="p-2"
        style={{
          margin: 0,
          fontSize: fontSize,
          fontFamily: "monospace",
          overflowX: "auto",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
        }}
      >
        <code
          className="code-snippet"

        >{displayCode}</code>
      </pre>
      <i
        className="bx bx-copy-alt"
        style={{
          textAlign: "center",
          verticalAlign: "middle",
          fontSize: "16px",
          cursor: "pointer",
          marginLeft: "10px",
        }}
        onClick={() => {copyToClipboard(codeToBeCopied)}}
      ></i>
    </div>
  );
};

CodeBlock.propTypes = {
  displayCode: PropTypes.string.isRequired,
  codeToBeCopied: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
};

CodeBlock.defaultProps = {
  displayCode: "",
  codeToBeCopied: "",
  fontSize: "16px",
};

export default CodeBlock;